<div class="container-fluid page">
  <div class="d-flex align-items-center mb-3" style="gap: 20px">
    <span class="go-back" [attr.aria-hidden]="true" (click)="redirectTo()">
      <img src="assets/images/arrow-left.svg" alt="" />Source Countries
    </span>
    <img src="assets/images/arrow-right.svg" alt="" />
    <ng-container *ngIf="!isEdit">New</ng-container>
    <ng-container *ngIf="isEdit">Edit</ng-container>
    Source Country
  </div>
  <form
    class="mat-form"
    [formGroup]="upsertSourceCountryForm"
    (ngSubmit)="onSubmit()">
    <div class="row mt-2">
      <div class="col-12">
        <mat-card>
          <div class="row">
            <div class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onCountryChange($event)"
                [inputData]="attrConstant.srcCountryName"
                [selectOptions]="countryList | async"
                [bindLabel]="'country_name'"
                [bindValue]="'country_name'"
                [formControlName]="
                  attrConstant.srcCountryName.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.srcCountryCode"
                [formControlName]="
                  attrConstant.srcCountryCode.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.srcCountryAlpha2Code"
                [formControlName]="
                  attrConstant.srcCountryAlpha2Code.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.srcCurrencySupported"
                [formControlName]="
                  attrConstant.srcCurrencySupported.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.srcMobileCode"
                [formControlName]="
                  attrConstant.srcMobileCode.key
                "></app-input-template>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <button class="btn primary-btn w-100 mt-3">Submit</button>
  </form>
</div>
